interface props {
    isOpen: boolean
}

export default function UploadLogoLoader({ isOpen }: props) {
    return(
        <>
            {
                isOpen &&
                <div className="modal-overlay-logo">
                    <div className="modal-content-logo">
                        <div className="loader-circle" style = {{ margin: 'auto'}}>
                            <div className="inner-circle"></div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}